import * as React from 'react';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import saveAppNotificationOptions from './orchestrators/saveAppNotificationOptions';
import isAppNotificationsOptionDirty from './utils/isAppNotificationsOptionDirty';
import discardAppNotificationOptions from './mutators/discardAppNotificationOptions';
import AppNotificationsOptionFull from './components/AppNotificationsOptionFull';
var AppNotificationsOptions = {
    key: 'appNotifications',
    titleStringKey: 'optionTitle_notificationsInAppNotifications',
    searchTermsStringKey: 'optionTitle_notificationsInAppNotifications',
    isHidden: function () { return !isControlFeatureEnabled('fwk-inAppNotifications'); },
    fullOptionFormSettings: {
        render: function () { return React.createElement(AppNotificationsOptionFull, null); },
        isDirty: isAppNotificationsOptionDirty,
        onSave: saveAppNotificationOptions,
        onDiscard: discardAppNotificationOptions,
    },
};
export default AppNotificationsOptions;
//# sourceMappingURL=AppNotificationsOption.js.map